"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileSubMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobileMenu = require("./MobileMenu.styled");

var _Text = require("../../../Text");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MobileSubMenuItem = function MobileSubMenuItem(props) {
  var children = props.children,
      href = props.href,
      target = props.target;
  return _react.default.createElement(_MobileMenu.StyledMobileMenuItemLink, {
    tertiary: true,
    href: href,
    target: target
  }, _react.default.createElement(_Text.Text, {
    level: "normal"
  }, children));
};
/**
 * Definition of default values for component props
 */


exports.MobileSubMenuItem = MobileSubMenuItem;
MobileSubMenuItem.defaultProps = {
  href: undefined,
  target: undefined
};
MobileSubMenuItem.propTypes = {
  href: _propTypes.default.string,
  target: _propTypes.default.string
};